<template>
    <div class="coordinacion-dashboard">
        <div style="background: #E0F7FA; padding: 5px 10px; border-bottom: 1px solid #00BCD4">
            <el-row :gutter="20">
                <el-col :sm="12" :offset="0">
                    <h4 style="margin:10px 20px">COORDINACIÓN DE RECETAS</h4>
                </el-col>

            </el-row>
        </div>
        <div class="dashboard-content">

        </div>
    </div>
</template>

<script>
export default {
    name: 'CoordinacionDashboard',
    data() {
        return {
            // Datos del dashboard
        }
    }
}
</script>

<style lang="scss" scoped>
.coordinacion-dashboard {
    padding: 0px;
    
    h2 {
        color: #409EFF;
        margin-bottom: 30px;
    }
    
    .dashboard-content {
        .dashboard-card {
            margin-bottom: 20px;
            cursor: pointer;
            transition: all 0.3s ease;
            
            &:hover {
                transform: translateY(-5px);
                box-shadow: 0 8px 25px rgba(0,0,0,0.15);
            }
            
            .card-content {
                text-align: center;
                padding: 20px;
                
                .card-icon {
                    font-size: 48px;
                    color: #409EFF;
                    margin-bottom: 15px;
                }
                
                h3 {
                    margin: 10px 0;
                    color: #303133;
                }
                
                p {
                    color: #606266;
                    margin: 0;
                }
            }
        }
    }
}
</style> 